<script>
import vSelect from 'vue-select'
import {ProductionFlag} from "@/libs/echa";
export default {
    components: {vSelect},
    props: {
        selected: {
            required: true
        },
        disabled: {
            type: Boolean,
            required: true
        }
    },
    data() {
        let options = [];
        ProductionFlag.toArray().forEach(option => {
            options.push(this.enumToValueObject(option));
        });

        return {
            value: this.selected ? this.enumToValueObject(this.selected) : null,
            options: options
        };
    },
    methods: {
        enumToValueObject(option) {
            return {
                label: this.$t('Component(ProductionFlagEnum):' + option),
                id: option
            };
        }
    },
    watch: {
        selected() {
            this.value = this.enumToValueObject(this.selected);
        }
    }
}
</script>

<template>
    <v-select
        :disabled="disabled"
        v-model="value"
        title=""
        :options="options"
        @input="$emit('input', value)"
        :placeholder="$t('Component(ProductionFlag):placeholder')"
    />
</template>
